<script lang="ts">
    import type { Snippet } from "svelte";

    /**
     * Shared pill-toggle group.
     * Renders a horizontal row of rounded-full pill buttons with
     * consistent sizing across the site (h-9, rounded-full, bg-base-300).
     *
     * Provide an `option` snippet for custom content (icons, images, mixed),
     * or omit it to get a default text-only pill using `option.label`.
     */

    export interface ToggleOption {
        value: string;
        label: string;
        title?: string;
    }

    let {
        options,
        value = $bindable(),
        onchange,
        option: optionSnippet,
    }: {
        options: ToggleOption[];
        value: string;
        onchange?: (value: string) => void;
        option?: Snippet<[ToggleOption, boolean]>;
    } = $props();
</script>

<div class="flex items-center rounded-full bg-base-300 p-1">
    {#each options as opt (opt.value)}
        {@const isActive = value === opt.value}
        <button
            type="button"
            class="flex items-center justify-center rounded-full px-3 py-1.5 h-9 text-sm font-semibold transition-colors cursor-pointer
                   {isActive ? 'bg-primary/25' : 'hover:bg-base-content/10'}"
            onclick={() => {
                value = opt.value;
                onchange?.(opt.value);
            }}
            title={opt.title ?? opt.label}
            aria-pressed={isActive}
        >
            {#if optionSnippet}
                {@render optionSnippet(opt, isActive)}
            {:else}
                <span class={isActive ? "text-primary" : "text-base-content/60"}>{opt.label}</span>
            {/if}
        </button>
    {/each}
</div>
